import React, {useRef} from "react";
import '../../styles/components/courses/courses-page.scss';
import TabbedNavigation from "../tabbedNavigation/TabbedNavigation";
import {cardClicked, selectCourseCategoryTab, displayInfoModal, useCoursesPageViewModel} from "../../services/courses/courses";
import InfoModal from "../common/InfoModal";
import ICourseCard from "../../models/view/coursesPage/ICourseCard";
import CourseCard from "./CourseCard";
import {FontIcon} from "../common/FontIcon";
import useScroll from "../common/hooks/useScroll";

// Perhaps it'd be better to move this file to a shared location, or import into the component-specific SCSS file courses-page.scss, eventually.
import s from "../../modules/songs/songs-navigation-item/SongsPageNavigationItem.module.scss";
import ICoursesPage from "../../models/view/coursesPage/ICoursesPage";

export default function CoursesPage() {
  const coursesPageViewModel = useCoursesPageViewModel();
  const cardEls = createCardElements(coursesPageViewModel.courseCards, cardClicked);
  const infoModalEl = createInfoModalElement(coursesPageViewModel.isInfoModalVisible);
  const scrollableContentRef = useRef<HTMLElement>(document.createElement('main'));
  const tabs = createTabs(coursesPageViewModel);

  useScroll(scrollableContentRef, "coursesScrollPosition", [cardEls]);

  //TODO: Loading
  return (
    <div className="courses-page">
      {infoModalEl}
      <header className="header">
        <h1>Courses</h1>
        <button className={"info-icon"} onClick={()=> displayInfoModal(true) }>
          <FontIcon icon={"icon-info"}/>
        </button>
        <div className="category-tabs">{tabs}</div>
      </header>
      <main ref={scrollableContentRef} className="scrollable-content">
        <div className="cards2">{cardEls}</div>
      </main>
      <footer className="footer">
        <TabbedNavigation/>
      </footer>
    </div>
  );
}

function createInfoModalElement(isVisible: boolean){
  if(!isVisible) {
    return null;
  }

  return <InfoModal onClose={()=> displayInfoModal(false)} title={"About Courses"} icon={"icon-courses"} text={<div>
    Welcome to Courses &mdash; your library of topic-specific lessons! Here you&apos;ll find content designed
    to supplement Bootcamp lessons, as well as niche topics that will help expand your musical knowledge.
  </div>}/>
}

function createTabs(coursesPageViewModel: ICoursesPage){
  return coursesPageViewModel.tabs?.map((tab) => {
    return createTab(tab, coursesPageViewModel.selectedTab);
  });
}

function createTab(tab: string, selectedTab?: string){
  const isActive = selectedTab? tab === selectedTab : false;
  const classNames = isActive ? [s.navItem, s.active] : [s.navItem];
  return <div key={tab} className={classNames.join(` `)}>
    {/* This tab should really be a button instead of a div. */}
    <div className={s.navLink} onClick={() => selectCourseCategoryTab(tab)}>{tab}</div>
  </div>
}

function createCardElements(cards: ICourseCard[], onClick: (c: ICourseCard) => void){
  return cards.map((c, index) => createCardElement(c, index, onClick));
}

function createCardElement(card: ICourseCard, index: number, onClick: (c: ICourseCard) => void){
  return <CourseCard key={`course-card-${index}`} cardModel={card} onClick={() => {onClick(card)}}/>
}
